import React from 'react';
import { Button, Box } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const BadgeButton = ({ 
  onClick, 
  startIcon, 
  children, 
  showBadge = false,
  backgroundColor = '#667eea',
  size = "small",
  variant = "contained",
  color = "primary",
  style = {},
  ...otherProps 
}) => {
  const buttonStyle = {
    backgroundColor: backgroundColor,
    border: 0,
    color: 'white',
    boxShadow: '0 2px 4px rgba(0, 0, 0, .2)',
    minWidth: '120px',
    height: '36px',
    fontSize: '12px',
    textTransform: 'none',
    width: '100%',
    '&:hover': {
      backgroundColor: backgroundColor,
      opacity: 0.9,
    },
    ...style
  };

  return (
    <Box style={{ 
      position: 'relative', 
      // display: 'inline-block',
      margin: '2px',
      display: 'flex',
      flexBasis:'170px',
    }}>
      <Button
        size={size}
        variant={variant}
        sx={buttonStyle}
        onClick={onClick}
        startIcon={startIcon}
        {...otherProps}
      >
        {children}
      </Button>
      {showBadge && (
        <CheckCircle 
          style={{ 
            position: 'absolute', 
            top: -5, 
            right: -5, 
            fontSize: 16, 
            color: '#4caf50',
            backgroundColor: 'white',
            borderRadius: '50%',
            border: '1px solid white'
          }} 
        />
      )}
    </Box>
  );
};

export default BadgeButton;

